import React from "react";

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

/**
 * External links → new tab safely. Stops propagation so parent bubble clicks don't interfere.
 */
export function SmartLink({ href, children, onClick, ...rest }: Props) {
  const isExternal = /^https?:\/\//i.test(href);
  return (
    <a
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
